/* eslint-disable import/prefer-default-export */
import { Link } from 'react-router-dom';
import {
  ComboBox,
  Button,
  FormLabel,
  DropdownSkeleton,
  Loading,
  TextArea,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
} from 'carbon-components-react';
import { Online, Offline } from './OnLineOffLine';
import React, { useState, useEffect, useRef } from 'react'; //RITM1064131
import { IsInRole } from '../../helpers/authorization/Policies'; //RITM1420951

export const WFActionModal = (props) => {
  const isConfirmButtonDisabled = () => {
    return (
      (props.approver == null && props.withApprover) ||
      (props.withTimeApproval && props.month == null && props.trimester == null) ||
      (props.withTimeApproval && props.year == null)
    );
  };
  const Role = props.approverRole == 'Division Manager' ? 'Consolidator' : props.approverRole;
  const year = new Date().getFullYear();

  const [isControlsVisible, setIsControlsVisible] = useState(false); //RITM1064131
  const [isClose, setIsClose] = useState(false); //RITM1064131

  //RITM1064131
  useEffect(() => {
    if (isClose) {
      setIsControlsVisible(false);
      setIsClose(false);
    }
  }, [isClose]);

  useEffect(() => {
    return () => {
      setIsControlsVisible(false);
    };
  }, [props.show]);
  //End

  //RITM0574609
  const years = Array.from(new Array(5), (val, index) => (index + (year - 2)).toString());

  const months = [
    { name: 'Jan', id: 1 },
    { name: 'Feb', id: 2 },
    { name: 'Mar', id: 3 },
    { name: 'Apr', id: 4 },
    { name: 'May', id: 5 },
    { name: 'Jun', id: 6 },
    { name: 'Jul', id: 7 },
    { name: 'Aug', id: 8 },
    { name: 'Sep', id: 9 },
    { name: 'Oct', id: 10 },
    { name: 'Nov', id: 11 },
    { name: 'Dec', id: 12 },
  ];
  const trimesters = [
    { name: 'Jan - Feb - Mar', id: 1 },
    { name: 'Apr - May - Jun', id: 2 },
    { name: 'Jul - Aug - Sep', id: 3 },
    { name: 'Oct - Nov - Dec', id: 4 },
  ];

  //RITM0646764
  const withApproverAndWarning = (props.withApprover && (props.approverWarning !== null && props.approverWarning !== undefined && props.approverWarning !== '')) || false;

  //RITM1064131
  const hideApproverDetails = (inputValue) => {
    if (props.user != undefined && props.user != null && inputValue != null) {
      if (props.user.id === inputValue.id && IsInRole(props.user, 'Data Approver') && props.action === 'Submit') //RITM1420951
        setIsControlsVisible(true);
      else
        setIsControlsVisible(false);
    }
    else
      setIsControlsVisible(false);
  }
  //End

  return (
    props.show && <ComposedModal //RITM1064131
      className="light-modal box-medium-modal"
      open={props.show}
      danger="false"
      onClose={(evt) => { //RITM1064131
        const isXButton = evt?.target?.closest('button')?.classList.contains('bx--modal-close');
        if (isXButton) {
        setIsClose(true); 
        }
        //End
        return false;
      }}
      //key={isClose} //RITM1064131
    >
      <ModalHeader
        className="margin-modal"
        title={props.title}
        iconDescription="Close"
        buttonOnClick={props.module != undefined && props.module == 'Incident' && props.onClose != undefined ? props.onClose : props.onCancel} //RITM1216061 //RITM1468542 //RITM1510731
      ></ModalHeader>

      <ModalBody className="margin-modal modal-nooverflow confirm-modal">
        {withApproverAndWarning ? (
          !isControlsVisible ? ( //RITM1064131
            <div>
              <p className="text-alert">{props.approverWarning}</p>
              <FormLabel className="some-class">{Role}</FormLabel>
              {props.isLoadingOptions ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="combo-approval"
                  className="selection-items-list-costum"
                  placeholder={'Select ' + Role}
                  items={props.approverOptions}
                  itemToString={(item) =>
                    item ? item.name + ' ' + item.surname + ' (' + item.email + ')' : ''
                  }
                  itemToElement={(item) =>
                    item ? `${item.name + ' ' + item.surname + ' (' + item.email + ')'} ` : ''
                  }
                  onChange={({ selectedItem }) => {hideApproverDetails(selectedItem); props.onApproverSelect(selectedItem) }}
                />
              )}
            </div>
          ) : (<p style={{ whiteSpace: "pre-line", fontSize: "14px", textAlign: "left" }}>{`You have selected the compiler as the data approver`}</p>)
        ) : props.withApprover ? (
          !isControlsVisible ? ( //RITM1064131
            <div>
              <FormLabel className="some-class">{Role}</FormLabel>
              {props.isLoadingOptions ? (
                <DropdownSkeleton />
              ) : (
                <ComboBox
                  id="combo-approval"
                  className="selection-items-list-costum"
                  placeholder={'Select ' + Role}
                  items={props.approverOptions}
                  itemToString={(item) =>
                    item ? item.name + ' ' + item.surname + ' (' + item.email + ')' : ''
                  }
                  itemToElement={(item) =>
                    item ? `${item.name + ' ' + item.surname + ' (' + item.email + ')'} ` : ''
                  }
                  onChange={({ selectedItem }) => { hideApproverDetails(selectedItem); props.onApproverSelect(selectedItem) }}
                />
              )}
            </div>
          ) : (<p style={{ whiteSpace: "pre-line", fontSize: "14px", textAlign: "left" }}>{`You have selected the compiler as the data approver`}</p>)
          //End
        ) : (
          <div>
            {/* RITM1216061 */}
            {!props.customMessage || (props.customMessage != undefined && props.customMessage == null) ? <p>{`Do you want to ${props.action.toLowerCase()} selected entities?`}</p> : <p style={{ fontSize: "18px", textAlign: "center" }}>{props.customMessage}</p>}
            {props.customMessage2 != undefined && props.customMessage2 != null ? <p style={{ whiteSpace: "pre-line", fontSize: "12px", textAlign: "center" }}>{props.customMessage2}</p> : null} {/* RITM1216061 */}
            {props.approvalNotesRequired ? (
              <TextArea
                maxLength={5000}
                id="approvalNotes"
                placeholder="Notes"
                value={props.approvalNotes}
                onChange={props.onApprovalNotesChange}
                hideLabel={true}
                labelText=""
                light
                rows={2}
                cols={100}
              />
            ) : null}
          </div>
        )}

        {props.withTimeApproval ? (
          <div>
            <FormLabel>Year</FormLabel>
            <ComboBox
              id="cb_year"
              placeholder="Year"
              items={years}
              onChange={props.onApprovalYearChange}
              itemToString={(item) => item || ''}
            />
            {props.approvalTimeIntervalType === 'trimester' ? (
              <>
                <FormLabel>Trimester</FormLabel>
                <ComboBox
                  id="cb_appTTT_T"
                  placeholder="Trimester"
                  items={trimesters}
                  onChange={props.onApprovalTrimesterChange}
                  itemToString={(item) => (item ? item.name : '')}
                  selectedItem={trimesters.find((t) => props.trimester === t.id) || null}
                />
              </>
            ) : (
              <>
                <FormLabel>Month</FormLabel>
                <ComboBox
                  id="cb_appTTT_M"
                  placeholder="Month"
                  items={months}
                  onChange={props.onApprovalMonthChange}
                  itemToString={(item) => (item ? item.name : '')}
                  selectedItem={months.find((m) => props.month === m.id) || null}
                />
              </>
            )}
          </div>
        ) : null}

        <div >
          <div className="bx--col">
            <ul>
              {props.validationMessages.map((e) => (
                <li className="srv-validation-message" key={e}>
                  {e}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {/* RITM1064131 */}
        <Button className="button--max-width" kind="secondary" onClick={() => { setIsClose(true); props.onCancel() }}>
          Cancel
        </Button>
        <Online>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={() => { props.onConfirm() }}
            disabled={isConfirmButtonDisabled()}
          >
            Confirm
          </Button>
        </Online>
        <Offline>
          <Button className="button--max-width" kind="primary" onClick={() => { props.onConfirm() }} disabled>
            Confirm
          </Button>
        </Offline>
        {/* End */}
      </ModalFooter>
      {!props.isLoadingOperation ? null : <Loading></Loading>}
    </ComposedModal>
  );
};
